<template>
  <div class="con">
    <InfoCard
      class="InfoCard"
      v-for="(x, i) in list"
      :key="i"
      v-bind="x"
    ></InfoCard>
  </div>
</template>

<style scoped>
.InfoCard {
  max-width: 800px;
  width: calc(100% - 64px);
  margin: 16px auto;
}
</style>

<script>
import InfoCard from "@/components/company/InfoCard.vue";
export default {
  components: {
    InfoCard
  },
  data() {
    return {
      list: [
        {
          title: "企业愿望",
          arr: ["企业发展与员工利益共享", "追求更高品质，满足顾客需求"],
          style_blue: true
        },
        {
          title: "企业目标",
          arr: ["全力打造国内一流输变电智能监测行业的民族品牌"],
          style_blue: true
        },
        {
          title: "企业精神",
          arr: ["团结拼搏", "科技创新", "锐意进取", "追求卓越"],
          style_blue: true
        },
        {
          title: "经验理念",
          arr: ["市场导向", "人才为本", " 技术引领", "体系保障"],
          style_blue: true
        },
        {
          title: "核心价值观",
          arr: [
            "自主创新—企业发展不竭的动力",
            "质量品牌—满足顾客需求是企业永远追求的目标"
          ],
          style_blue: true
        }
      ]
    };
  }
};
</script>
